import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { of, catchError, map } from 'rxjs';
import { FeatureFlagService } from '../../feature-flag/services/feature-flag.service';

/**
 * Ce featureGlagGuard permet de laisser passer sur la route si pas de flag, sinon il vérifie le flag et laisse passer si il est
 * à true, exemple d'utilisation 
 * 
 * {
 * path: 'inscription',
 * canActivate: [featureFlagGuard],
 * data: { featureFlag: 'inscription-autonome' },
 * loadComponent: () => import('./inscription.component').then(m => m.InscriptionComponent),
 * }

 * @param route 
 * @returns 
 */

export const featureFlagGuard: CanActivateFn = (route) => {
  const featureFlagServce = inject(FeatureFlagService);
  const router = inject(Router);

  const flagName = route.data?.['featureFlag'] as string | undefined;

  if (!flagName) {
    return true;
  }

  return featureFlagServce.hasFlag$(flagName).pipe(
    map((enabled) => (enabled ? true : router.createUrlTree(['/']))),
    catchError(() => of(router.createUrlTree(['/']))),
  );
};
